import React, { useEffect, useState } from "react";
import useTranslation from "next-translate/useTranslation";
import Popup from "../../../components/ui/popup";
import Spinner from "../../../components/ui/spinner";
import { useGamePlay, setGameSync } from "../../../redux/gamePlay";

export default function GameSyncPopup() {
  const { gameSync } = useGamePlay();

  const { t } = useTranslation("common");

  useEffect(() => {
    if (gameSync) {
      const timeout = setTimeout(() => {
        setGameSync(false);
      }, 500);
      return () => {
        clearTimeout(timeout);
      };
    }
  }, [gameSync]);

  if (!gameSync) {
    return null;
  }

  return (
    <Popup onClose={null} title={t("Reconnecting")}>
      <div style={{ padding: "10px" }}>
        <Spinner blue />
      </div>
    </Popup>
  );
}
